module.exports = __webpack_public_path__ + "static/media/48268862_2308768002531711_1174871759606775808_o-thumb.27cf41c7.jpg";